import { render, staticRenderFns } from "./TableBullet.vue?vue&type=template&id=035a5c15&"
import script from "./TableBullet.vue?vue&type=script&lang=js&"
export * from "./TableBullet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports